import * as React from "react";
//import testData from "./testdata.json";
import styles from "./StatusPageWidget.scss";
import { faWrench } from "@fortawesome/fontawesome-pro-solid";
import { faExternalLink } from "@fortawesome/fontawesome-pro-light";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";

interface IStatusMessage{
	messageType: string;
	messageName: string;
	messageContent: string;
	messageDateCreated: string;
	messageDateScheduled?: string;
	fontSize: number;
	maintenanceStatus? : string;
}

export class StatusPageMessageGenerator{
	public static getIncidents(status, size: number, advancedDetails?: boolean) {
		let ins;
	//	if (status.status.indicator !== "none") {
			if (status.incidents.length > 0) { // When there are incidents and we have informations about them
				ins = status.incidents.map((incident, index) => {

				if (!advancedDetails || incident.incident_updates.length === 1) {
					return (<div key={incident.id}>
						<StatusMessage
							messageType="Incident"
							messageName={incident.name}
							messageContent={incident.incident_updates[0].body}
							messageDateCreated={incident.created_at}
							fontSize={size}

						/>
						<a
							style={{fontSize: size - 2 + "px", color: "grey"}}
							href={incident.shortlink}
							target="_blank"
						>
							Click here to view more details {" "}
							<FontAwesomeIcon icon={faExternalLink}/>
						</a>
						{!(index === status.incidents.length - 1) && <hr className={styles.hrStatus}/>}
						</div>
					);
						}else {
							return (
									<div key={incident.id}>
											<StatusMessage
												messageType={`Incident`}
												messageName={incident.name}
												messageContent={incident.incident_updates[incident.incident_updates.length - 1].body}
												messageDateCreated={incident.created_at}
												fontSize={size}
												/>
											<hr style={{margin: "5px 0"}}/>
											<StatusMessage
												messageType="Newest Update:"
												messageName=""
												messageContent={incident.incident_updates[0].body}
												messageDateCreated={incident.incident_updates[0].created_at}
												fontSize={size}
											/>
											<a
												style={{fontSize: size - 2 + "px", color: "grey"}}
												href={incident.shortlink}
												target="_blank"
											>
												Click here to view more details {" "}
												<FontAwesomeIcon icon={faExternalLink}/>
											</a>
										{incident.incident_updates.length > 1 &&
										<div>
											{!(index === status.incidents.length - 1) && <hr className={styles.hrStatus}/>}
										</div>}
										{!(index === status.incidents.length - 1) && <hr className={styles.hrStatus}/>}
									</div>
								);
						}
					}
				);
			} else if (status.status.indicator !== "none") { // When there are incidents but we have no information about them
				ins =
					<div>
						<StatusMessage
							messageType="Incident"
							messageName="Unknown Incident"
							messageContent="We cannot provide any information to this problem right now! We're working on a solution"
							messageDateCreated=""
							fontSize={size}
						/>
					</div>;
			}
		//}
		return ins;
	}

	public static getMaintence(status, size: number, advancedDetails? : boolean) {
		let main;
		main = status.scheduled_maintenances.map((maintenance, index) => {
			if (!advancedDetails || maintenance.incident_updates.length === 1) {
				return (
					<div key={maintenance.id}>
						<StatusMessage
							messageType={`Maintenance`}
							messageName={maintenance.name}
							messageContent={maintenance.incident_updates[0].body}
							messageDateCreated={maintenance.created_at}
							messageDateScheduled={maintenance.scheduled_for}
							fontSize={size}
							maintenanceStatus={maintenance.status}
						/>
						<a
							style={{fontSize: size - 2 + "px", color: "grey"}}
							href={maintenance.shortlink}
							target="_blank"
						>
							Click here to view more details {" "}
							<FontAwesomeIcon icon={faExternalLink}/>
						</a>
						{!(index === status.scheduled_maintenances.length - 1) && <hr className={styles.hrStatus}/>}
					</div>
					);
				} else {
					return (
						<div key={maintenance.id}>
								<StatusMessage
									messageType={`Maintenance`}
									messageName={maintenance.name}
									messageContent={maintenance.incident_updates[maintenance.incident_updates.length - 1].body}
									messageDateCreated={maintenance.created_at}
									messageDateScheduled={maintenance.scheduled_for}
									maintenanceStatus={maintenance.status}
									fontSize={size}
									/>
								<hr style={{margin: "5px 0"}}/>
								<StatusMessage
									messageType="Newest Update:"
									messageName=""
									messageContent={maintenance.incident_updates[0].body}
									messageDateCreated={maintenance.incident_updates[0].created_at}
									fontSize={size}
								/>
								<a
									style={{fontSize: size - 2 + "px", color: "grey"}}
									href={maintenance.shortlink}
									target="_blank"
								>
									Click here to view more details {" "}
									<FontAwesomeIcon icon={faExternalLink}/>
								</a>
							{maintenance.incident_updates.length > 1 &&
							<div>
								{!(index === status.scheduled_maintenances.length - 1) && <hr className={styles.hrStatus}/>}
							</div>}
							{!(index === status.scheduled_maintenances.length - 1) && <hr className={styles.hrStatus}/>}
						</div>
						);
				}
			}
		);
		return main;
	}
}

export class StatusPageError extends React.Component <any, {}>{
	constructor(props) {
		super(props);
	}

	public render() {
			return(
			<StatusMessage
				messageName = "StatusPageError"
				messageContent = "Couldn't get any data from our statuspage. Either you are not connected to the internet, or our statuspage is down!"
				messageType = "Error while Fetching!"
				fontSize = {10}
				messageDateCreated = ""
			/>
		);
	}
}


/**
 * This component contains the status messages
 *
 * props:
 * messageType: Incident or mainteance
 * messageName: Title of the message
 * messageContent: the content of the message
 */
export class StatusMessage extends React.Component <IStatusMessage, any>{
	constructor(props) {
		super(props);
	}

	private replaceNwBr () {
		return {__html: this.props.messageContent.replace(/\n/g, "<br>")};
	}

	public render() {
		let timeCreated = new Date (this.props.messageDateCreated);
		let timeScheduled = this.props.messageDateScheduled ? new Date (this.props.messageDateScheduled) : null;

		return(
			<div>
				<p style = {{fontSize: this.props.fontSize + 2 + "px", display: "block", lineHeight: "1.5"}}>
						<span
							style = {{fontSize : this.props.fontSize + "px"}}
						>
							{this.props.messageType} {" "}
							{
						<span style = {{fontSize: this.props.fontSize + "px", color: "grey", fontStyle: "italic"}}>
						{(this.props.messageDateScheduled) &&
							this.props.maintenanceStatus === "in_progress" ? <span style={{color: "steelblue"}}>In progress
							{/* MaintenanceIcon */}
								<span className="fa-stack" style={{fontSize: "7px", bottom: "-4px"}}>
									<FontAwesomeIcon icon = {faWrench} className = "fa-stack-2x" style = {{fontSize: "4px"}}/>
									<span className = {"fa-stack-2x " + styles.spinner}/>
								</span>
							{/* MaintenanceIconEnd */}
						</span>
						:
								(timeScheduled &&
								<span>
									<br/>
									{/* <FontAwesomeIcon icon={faClock}/> */}
									<span style={{fontSize: this.props.fontSize - 2 + "px", color: "grey"}}>scheduled for {" "}{
									` ${timeScheduled.toDateString()} - ${timeScheduled.getHours()}:${timeScheduled.getMinutes()}${timeScheduled.getMinutes() < 10 ? "0" : ""}`}
									</span>
								</span>)}
						</span>
						}
						</span>
				</p>
				{this.props.messageName}
				<span dangerouslySetInnerHTML={this.replaceNwBr()} className={styles.statusWidgetText} style={{ fontSize: this.props.fontSize + "px" }}/>

				{(this.props.messageDateCreated) &&
					<span style={{fontSize: this.props.fontSize - 2 + "px", color: "grey"}}>Message was created at:{
					` ${timeCreated.toDateString()} - ${timeCreated.getHours()}:${timeCreated.getMinutes()}${timeCreated.getMinutes() < 10 ? "0" : ""}`}
					</span>
				}
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/common/StatusPageWidget/StatusPage.tsx